import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { ShoppingCart as ShoppingCartIcon } from '../../icons';

export interface ShoppingCartCounterProps {
  className?: string;
  count: number;
  size: 's' | 'm';
}

const useStyles = makeStyles((theme: Theme) => ({
  shoppingCartCounter: {
    display: 'block',
    height: '45px',
    position: 'relative',
    width: '56px',

    '& .cartIcon': {
      color: theme.palette.primary.main,
      left: 'calc(50% - 10px)',
      position: 'absolute',
      top: 'calc(50% - 9px)',
    },
    '& .cartItemCounter': {
      color: theme.palette.primary.contrastText,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightBold,
      left: 'calc(50% - 11px)',
      lineHeight: theme.typography.pxToRem(13),
      position: 'absolute',
      textAlign: 'center',
      top: 'calc(50% - 10px)',
      width: '20px',
    },

    '&.small': {
      height: '24px',
      width: '24px',

      '& .cartIcon': {
        left: 0,
        top: 0,
      },
      '& .cartItemCounter': {
        fontSize: theme.typography.pxToRem(10),
        fontWeight: '700',
        left: 'calc(50% - 9px)',
        top: 'calc(50% - 8px)',
        width: '20px',
      },
    },
  },
}));

export function ShoppingCartCounter(
  props: ShoppingCartCounterProps,
): JSX.Element {
  const { className = '', count, size } = props;
  const classes = useStyles();

  const shoppingCartCounterStyles = clsx(
    classes.shoppingCartCounter,
    size === 's' && 'small',
    className && className,
  );

  return (
    <div className={shoppingCartCounterStyles}>
      <ShoppingCartIcon className="cartIcon" size={size} />
      <div className="cartItemCounter">{count}</div>
    </div>
  );
}
